<template>
  <div>
    <iframe
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/team/form?key=add`"
      allow="clipboard-read; clipboard-write"
    />

    <ModalReqOTP
      id="req-OTP-phone"
      title="Tambah Tim"
      :phone-number="profile.user_phone"
      :partner-id="profile.partner_id"
      :purpose="'team'"
      @on-confirm-button="requestTypeSelected"
    />

    <ModalVerifyOtp
      id="confirm-otp-phone"
      title="Verifikasi Kode OTP"
      :partner-id="profile.partner_id"
      :phone-number="profile.user_phone"
      :request-type="requestType"
      :purpose="'team'"
      label-confirm-button="Konfirmasi"
      @on-cancel-button="$bvModal.show('req-OTP-phone')"
      @on-confirm-button="onSubmit"
    />
  </div>
</template>

<script>
import ModalReqOTP from '@/views/components/modal/ModalReqOTP.vue'
import ModalVerifyOtp from '@/views/components/modal/ModalVerifyOTP.vue'
import { mapState } from 'vuex'
import { newAxiosIns } from '@/libs/axios'

export default {
  components: { ModalReqOTP, ModalVerifyOtp },
  data() {
    return {
      height: 0,
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      payload: {},
      source: null,
      requestType: null,
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
  },
  mounted() {
    window.addEventListener('message', event => {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const {
          type, data, route, source, payload,
        } = event.data

        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }

        if (source === 'add') {
          this.payload = payload
          this.$bvModal.show('req-OTP-phone')
        }

        if (route) {
          if (route.startsWith('/talent?tab')) {
            this.$router.replace(route)
            return
          }
          this.$router.push(route)
        }
      }
    })
  },
  methods: {
    async onSubmit(value) {
      const payload = {
        ...this.payload,
        verify_otp: {
          token: value.token,
          otp: value.otp,
        },
      }

      const url = '/auth/api/v1/teams'
      await newAxiosIns.post(url, payload)
        .then(() => {
          this.$router.replace('/talent')
          this.$toast_success({ message: 'Berhasil menambahkan team. Silahkan verifikasi email!' })
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal menambahkan team.' })
        })
    },
    requestTypeSelected(value) {
      this.requestType = value
      this.$bvModal.show('confirm-otp-phone')
    },
  },
}
</script>
